///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, toastSuccessActionCreators, articleLifeManagerActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getTimeline = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ARTICLE_LIFE_TIMELINE(payload.id, payload.year)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(articleLifeManagerActionCreators.getTimelineSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.getTimelineFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getTimelinePhases = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ARTICLE_LIFE_TIMELINE_PHASES(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(articleLifeManagerActionCreators.getTimelinePhasesSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.getTimelinePhasesFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getHeaderAndArticle = function* ({ payload }) {
	const idArticle = Number(payload.id)
	const apiCall = R.GET_HEADER_AND_ACTION_ARTICLE(idArticle)
	const user = yield select(selectIdsUser)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(articleLifeManagerActionCreators.getHeaderAndActionSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.getHeaderAndActionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postUnactiveItem = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const date = {
		dateToSet: payload.date,
	}
	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_deactivateNow_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.postUnactiveItemSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postUnactiveItemSuccessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postDeletedItem = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_deleteItem_success'
	const redirect = `${uriList.distributionItems}${uriList.distributionGroupRepo}`
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(articleLifeManagerActionCreators.postDeletedItemSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams, redirect))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postDeletedItemFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const postDeleteStopDeposit = function* ({ payload }) {
	const idArticle = Number(payload.id)
	const apiCall = R.POST_DELETE_STOP_DEPOSIT(idArticle)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_consignment_endDate_success'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(articleLifeManagerActionCreators.postDeleteStopDepositSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postDeleteStopDepositFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postActiveItem = function* ({ payload }) {
	const id = payload.id
	const query = payload.query

	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_activation_now_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(articleLifeManagerActionCreators.postActiveItemSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postActiveItemSuccessFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateStartDepositAction = function* ({ payload }) {
	const id = payload.id
	const date = {
		dateToSet: payload.date,
	}

	const apiCall = R.UPDATE_START_DEPOSIT_ACTION(id)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_consignment_startDate_edit_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.updateStartDepositActionSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.updateStartDepositActionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateStopDepositAction = function* ({ payload }) {
	const id = payload.id
	const date = {
		dateToSet: payload.date,
	}

	const apiCall = R.UPDATE_STOP_DEPOSIT_ACTION(id)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_consignment_endDate_edit_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.updateStopDepositActionSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.updateStopDepositActionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postAddStopDeposit = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const date = {
		dateToSet: payload.date,
	}

	const apiCall = R.POST_ADD_STOP_DEPOSIT(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_consignment_endDate_add_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.postAddStopDepositSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postAddStopDepositFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const postAddStartWithDeposit = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const date = {
		dateToSet: payload.date,
	}

	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_consignment_startDate_add_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.postAddStartWithDepositSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postAddStartWithDepositFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postDeleteAddStartWithDeposit = function* ({ payload }) {
	const idArticle = Number(payload.id)
	const apiCall = R.POST_DELETE_ADD_START_WITH_DEPOSIT(idArticle)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_consignment_startDate_delete_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(articleLifeManagerActionCreators.postAddStartWithDepositSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postAddStartWithDepositFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postScheduleActivateAction = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const date = {
		dateToSet: payload.date,
	}

	const apiCall = R.POST_SCHEDULE_ACTIVATE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_activation_scheduled_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.postScheduleActivateActionSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postScheduleActivateActionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postDeleteScheduledActivate = function* ({ payload }) {
	const idArticle = Number(payload.id)
	const apiCall = R.POST_DELETE_SCHEDULED_ACTIVATE(idArticle)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_activation_dateStart_edit_success'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(articleLifeManagerActionCreators.postDeleteScheduledActivateSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postDeleteScheduledActivateFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const updateScheduledActivateAction = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const date = {
		dateToSet: payload.date,
	}

	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_activation_dateStart_add_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.updateScheduledActivateActionSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.updateScheduledActivateActionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const postDeleteDesactivationScheduled = function* ({ payload }) {
	const id = payload.id
	const query = payload.query

	const date = {
		dateToSet: payload.date,
	}

	const apiCall = R.POST_DELETE_DESACTIVATION_SCHEDULED(id)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_deactivation_progressive_delete_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.postDeleteDesactivationScheduledSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postDeleteDesactivationScheduledFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postDeleteStopWithRestockAction = function* ({ payload }) {
	const id = payload.id
	const query = payload.query

	const date = {
		dateToSet: payload.date,
	}

	const apiCall = R.POST_DELETE_STOP_WITH_RESTOCK(id)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_restock_startDate_delete_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.postDeleteStopWithRestockActionSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postDeleteStopWithRestockActionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postScheduledDeactivateAction = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const body = payload.body

	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = !payload.isScheduled
		? 'toast__itemRef__timeline_action_deactivation_progressive_add_now_success'
		: 'toast__itemRef__timeline_action_deactivation_progressive_add_scheduled_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, body)

		yield put(articleLifeManagerActionCreators.postScheduledDeactivateActionSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postScheduledDeactivateActionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postCancelDeactivateAction = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_deactivation_progressive_cancel_success'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(articleLifeManagerActionCreators.postCancelDeactivateActionSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postCancelDeactivateActionFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postAddStopWithRestock = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const date = {
		dateToSet: payload.date,
	}
	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_restock_startDate_add_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.postAddStopWithRestockSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postAddStopWithRestockFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const postEditStopWithRestock = function* ({ payload }) {
	const id = payload.id
	const query = payload.query
	const date = {
		dateToSet: payload.date,
	}
	const apiCall = R.POST_LIFE_CYCLE_ACTION(id, query)
	const user = yield select(selectIdsUser)
	const MsgParams = 'toast__itemRef__timeline_action_restock_startDate_edit_success'

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, date)

		yield put(articleLifeManagerActionCreators.postEditStopWithRestockSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(articleLifeManagerActionCreators.postEditStopWithRestockFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_ARTICLE_LIFE_TIMELINE, getTimeline)
	yield takeLatest(ActionsTypes.GET_ARTICLE_LIFE_TIMELINE_PHASES, getTimelinePhases)
	yield takeLatest(ActionsTypes.GET_HEADER_ACTION_ARTICLE_LIFE, getHeaderAndArticle)
	yield takeLatest(ActionsTypes.POST_DELETED_ITEM, postDeletedItem)
	yield takeLatest(ActionsTypes.POST_UNACTIVE_ITEM, postUnactiveItem)
	yield takeLatest(ActionsTypes.POST_DELETE_STOP_DEPOSIT, postDeleteStopDeposit)
	yield takeLatest(ActionsTypes.POST_ACTIVED_ITEM, postActiveItem)
	yield takeLatest(ActionsTypes.UPDATE_START_DEPOSIT_ACTION, updateStartDepositAction)
	yield takeLatest(ActionsTypes.UPDATE_STOP_DEPOSIT_ACTION, updateStopDepositAction)
	yield takeLatest(ActionsTypes.POST_ADD_STOP_DEPOSIT, postAddStopDeposit)
	yield takeLatest(ActionsTypes.POST_ADD_START_WITH_DEPOSIT, postAddStartWithDeposit)
	yield takeLatest(ActionsTypes.POST_SCHEDULE_ACTIVATE_ACTION, postScheduleActivateAction)
	yield takeLatest(ActionsTypes.POST_DELETE_ADD_START_WITH_DEPOSIT, postDeleteAddStartWithDeposit)
	yield takeLatest(ActionsTypes.POST_DELETE_SCHEDULED_ACTIVATE, postDeleteScheduledActivate)
	yield takeLatest(ActionsTypes.UPDATE_SCHEDULED_ACTIVATE_ACTION, updateScheduledActivateAction)
	yield takeLatest(ActionsTypes.POST_SCHEDULED_DEACTIVATE_ACTION, postScheduledDeactivateAction)
	yield takeLatest(ActionsTypes.POST_CANCEL_DEACTIVATE_ACTION, postCancelDeactivateAction)
	yield takeLatest(ActionsTypes.POST_DELETE_DESACTIVATION_SCHEDULED, postDeleteDesactivationScheduled)
	yield takeLatest(ActionsTypes.POST_DELETE_STOP_WITH_RESTOCK, postDeleteStopWithRestockAction)
	yield takeLatest(ActionsTypes.POST_ADD_STOP_WITH_RESTOCK, postAddStopWithRestock)
	yield takeLatest(ActionsTypes.POST_EDIT_STOP_WITH_RESTOCK, postEditStopWithRestock)
}

export default sagas
